<!--
 * @Author: DY
 * @Date: 2024-12-05 16:52:54
 * @LastEditTime: 2025-03-25 10:18:35
 * @Description: 柴油领用申请列表
 * @FilePath: \ShiMo_Mobile\src\views\storage\dieselFuelRequisitionApply\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="dieselFuelRequisitionApply commonListStyles">
            <HeaderNav
                header-title="柴油领用申请"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ leftCallBack: swiperright, rightCallBack: openForm, iconName: 'sm-icon-test' }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">柴油出库单号：{{ item.outstock_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status | loadStatus }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_36@2x.png" alt="">
                                            <span>车牌号：{{ item.car_license }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>管理部门：{{ item.manage_dept_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>柴油代码：{{ item.material_code }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>申请时间：{{ item.creation_time }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="item.status === 0">
                                            <button @click="submit(item)">
                                                提交
                                            </button>
                                            <button @click="openForm(item, 'edit')">
                                                编辑
                                            </button>
                                            <button @click="deleteApply(item, 'edit')">
                                                删除
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button @click="openForm(item, 'see')">
                                                查看
                                            </button>
                                        </template>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'diesel-fuel-requisition-apply',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'diesel-fuel-requisition-apply');
        }
        next();
    },
    data() {
        return {
            tableCode: 'outstock_oil',
        };
    },
    filters: {
        loadStatus(val) {
            const status = ['待提交', '待审核', '未通过', '待出库', '已出库', '已作废'];
            return status[val];
        },
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {},
    mounted() {},
    methods: {
        async submit(item) {
            this.$dialog.confirm({
                message: `确认提交出库单 \n【${item.outstock_number}】吗？`,
            }).then(async () => {
                const res = await this.submitRequest(item.id);
                if (res) {
                    this.$toast.success('提交成功。');
                    this.onRefresh();
                }
            });
        },
        deleteApply(item) {
            this.$dialog.confirm({
                message: `确认删除领用申请 \n【${item.outstock_number}】吗？`,
            }).then(async () => {
                const res = await this.deleteRequest(item.id);
                if (res) {
                    this.$toast('删除成功！');
                    this.onRefresh();
                }
            });
        },

        openForm(item = null, type = 'add') {
            this.$router.isBack = 2;
            this.$router.push({ name: 'dieselFuelRequisitionApplyForm', params: { type, data: item } });
        },

        submitRequest(id) {
            return this.$axios.$post(`interfaceApi/procurement/outstock_oil/submit?id=${id}`, {});
        },
        deleteRequest(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock_oil/cancel/${id}`, {});
        },
    },
};
</script>
<style lang="stylus">
.dieselFuelRequisitionApply
    section
        position: relative
        .van-pull-refresh
            height: calc(100% - 44rpx) !important
</style>
